import { helper } from '@ember/component/helper';

// nonzero returns the first parameter, if it's nonzero.  If it's zero, an empty string is returned.
export function nonzero(params) {
  return params[0] === 0 ? '' : params[0];
}

export default helper(nonzero);
